import React, { useState, useEffect } from "react";
import styled from "styled-components";

const STORAGE_KEY = "carmelika_cookies_accepted";

export default function CookieBanner({ navigate }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Banner role="alert" aria-live="polite">
      <BannerText className="font13">
        אנו משתמשות בעוגיות (Cookies) לשיפור חוויית הגלישה ולניתוח שימוש באתר.
        המשך גלישה מהווה הסכמה לשימוש בעוגיות. לפרטים ראי את{" "}
        <PolicyLink onClick={() => { accept(); navigate("privacy"); }}>
          מדיניות הפרטיות
        </PolicyLink>
        {" "}שלנו.
      </BannerText>
      <BannerBtn onClick={accept} className="pinkBg whiteColor radius8 semiBold font13">
        הבנתי ✓
      </BannerBtn>
    </Banner>
  );
}

const Banner = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 8000;
  background: rgba(255, 245, 252, 0.94);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border-top: 1px solid rgba(203, 29, 133, 0.25);
  box-shadow: 0 -10px 30px -12px rgba(73, 8, 57, 0.3);
  padding: 16px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  direction: rtl;
  box-shadow: 0 -4px 20px rgba(73, 8, 57,0.2);
  /* on phones float above the accessibility button and host badges at the bottom edge */
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    right: 12px;
    left: 12px;
    bottom: 96px;
    padding: 14px 16px;
    border: 1px solid rgba(203, 29, 133, 0.25);
    border-radius: 16px;
  }
`;
const BannerText = styled.p`
  color: var(--ink-soft);
  line-height: 1.6;
  flex: 1;
`;
const PolicyLink = styled.span`
  color: var(--rose-600);
  cursor: pointer;
  text-decoration: underline;
  &:hover { color: var(--rose-700); }
`;
const BannerBtn = styled.button`
  padding: 10px 22px;
  border: none;
  cursor: pointer;
  white-space: nowrap;
  @media (max-width: 600px) {
    width: 100%;
    padding: 12px 22px;
  }
`;
